import React from 'react';
import { TextField } from '@mui/material';

const DecimalInput = ({ label, value, onChange,disable, ...props }) => {

  // Handle changes in the input field
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    
    // Validate and allow only numbers and decimal points
    if (/^\d*\.?\d*$/.test(newValue)) {
      onChange(newValue); // Update the state if valid
    } else {
      // Optionally, show feedback or handle invalid characters
      console.warn("Invalid input: only numbers and one decimal point are allowed");
    }
  };

  return (
    <TextField
      fullWidth
      label={label}
      type="text"
      margin="normal"
      value={value}
      disabled={disable}
      onChange={handleInputChange}
      {...props}  // Pass additional props
    />
  );
};

export default DecimalInput;
